var ticker = $(".ticketsTicker"),
  initDate = new Date(2018,9,10),
  nowDate = new Date(),
  initPercent = 60,
  diffTime = Math.abs(initDate.getTime() - nowDate.getTime()),
  diffDays = Math.floor( diffTime / (1000 * 3600 * 24)),
  result;

if(diffDays <= 11) {
  result = initPercent + diffDays;
} else {
  result = initPercent + 11 + ((diffDays - 11) * 2);
}
if(result > 96) {
  result = 96;
}
ticker.text(result);
$("#progressbar").css("clipPath", "polygon(0% 0%, " + result + "% 0%, " + result + "% 100%, 0% 100%)");
$(".progress__wrap").css("opacity", "1");